module.exports = __webpack_public_path__ + "static/media/step-background-1.bcc715f4.png";